import type { QueryClient } from "@tanstack/react-query";
import type { getDeckOrPublic, SavedDeckDetail } from "./api";

type DeckDetailResult = Awaited<ReturnType<typeof getDeckOrPublic>>;

/** Publish the saved response before navigating back to the copy button. */
export async function cacheSavedDeck(
  client: QueryClient,
  owner: string,
  slug: string,
  detail: SavedDeckDetail,
) {
  const editKey = ["deck", slug];
  const detailKey = ["deck-detail", owner, slug, "auth"];
  // A read started before the save must not overwrite the saved response.
  await Promise.all([
    client.cancelQueries({ queryKey: editKey }),
    client.cancelQueries({ queryKey: detailKey }),
  ]);
  client.setQueryData(editKey, detail);
  client.setQueryData<DeckDetailResult>(detailKey, (previous) => ({
    ...previous,
    detail,
    isOwner: true,
    otherMatches: previous?.otherMatches ?? [],
  }));
}
